
  import { Vue, Component, Prop } from "vue-property-decorator";
  import Skeleton from "@/components/skeletonPlaceholder/Skeleton.vue";

  @Component({
    components: {
      Skeleton,
    },
  })
  export default class InputPlaceholder extends Vue {
    @Prop({ type: Number, default: 400 }) readonly width!: number;
  }
